<template>
  <div class="bg-[url('/img/web-texture.webp')] bg-cover bg-center width-full">
    <header
      class="position-relative overflow-visible width-screen bg-ms-maincolor display-flex md-justify-between align-items-center height-16 lg-height-32" >
      <div
        class="padding-left-3 sm:px-[7px] md-padding-x-3 lg-margin-auto my-0 width-full lg:w-11/12 display-flex align-items-center justify-between overflow-visible"
>
        <img class="width-48 md-width-64 height-auto" src="/external/img/smartdrone-logo.webp" alt="SmartDrone Logo">
        <nav class="display-flex display-flex-col sm:display-flex-row items-end sm:w-[65%] md:w-[55%] w-1/2">
          <button id="menu-button" class="sm:hidden rounded-lg h-12 w-10 mr-3" @click="menuToggle()">
            <svg class="w-10 h-10 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 24 24"
>
              <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 7h14M5 12h14M5 17h14" />
            </svg>
          </button>
          <ul id="navbar-menu"
              :class="{ 'max-h-0 opacity-0': menuClosed, 'h-auto opacity-100 menuOpened': !menuClosed }"
              class="desktop-open md:width-full justify-end ease-in-out absolute sm:max-h-full sm:static bg-ms-maincolor rounded-bl-md top-16 display-flex display-flex-row sm:display-flex-row text-ms-secondarycolor no-underline align-items-center"
>
            <li class="text-sm padding-3 sm-padding-2 xl-padding-5 sm-text-base lg-text-xl">
              <a class="transition-all ease-in-out hover-text-ms-hoverColor"
                 href="https://docs.google.com/forms/d/e/1FAIpQLSfHqi7e1XFp0F21nX80PrOZlR3_jnxQVUTnPK6kLaetZcvzMw/viewform"
>Solicitar cotización</a>
            </li>
            <li class="text-sm padding-3 sm-padding-2 xl-padding-5 sm-text-base lg-text-xl">
              <a class="transition-all ease-in-out hover-text-ms-hoverColor"
                 href="https://www.mercadolibre.com.uy/pagina/smartdroneshop#client=HOME&component_id=header_logo"
>Tienda</a>
            </li>
            <li class="text-sm padding-3 sm-padding-2 xl-padding-5 sm-text-base lg-text-xl">
              <a class="transition-all ease-in-out hover-text-ms-hoverColor" href="/login">Ingresar al Sistema</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>

    <main>
      <img class="onlydesktop width-full" src="/external/img/banners/desktop-banner.webp" alt="SmartDrone Banner">
      <img fetchpriority="high" class="md:hidden width-full" src="/external/img/banners/mobile-banner.webp"
           alt="SmartDrone Banner"
>
      <div class="w-11/12 my-0 mx-auto">
        <section class="my-16 md:my-24 lg:my-32">
          <h2 class="text-center text-ms-maincolor text-2xl sm:text-3xl md:text-4xl font-semibold overflow-hidden">
            Tu Solución de Reparación Integral
          </h2>

          <h3 class="text-center text-ms-maincolor text-xl font-light my-5">
            Para ti o para tu empresa
          </h3>

          <div class="display-flex display-flex-wrap justify-center my-7 md:p-5">
            <div class="shadow-lg items-center w-[40%] md:w-80 h-20 p-1 md:p-3 mx-2 md:mx-[6px] lg:mx-4 my-7 bg-ms-secondarycolor" v-for="(elem, index) in categoriesList" :key="index">
              <div class="w-full h-full flex items-center justify-between"> <img class="w-auto h-[50%] sm:h-[70%] md:h-[90%] border-r-[0.5px] pr-2 md:pr-4 border-ms-maincolor" :src="elem.iconImage" :alt="elem.name" /> <h4 class="w-2/3 text-center font-semibold text-xs sm:text-base md:text-lg text-ms-maincolor" >{{elem.name}}</h4> </div>
            </div>
          </div>
        </section>
        <section class="my-16 lg:my-16 display-flex display-flex-col justify-center align-items-center">
          <h1 class="text-center text-ms-maincolor text-2xl sm:text-3xl md:text-4xl font-semibold overflow-hidden">
            Smart Drone: ¡Reparamos Más que Celulares!
          </h1>

          <h3 class="lg:text-2xl text-center text-ms-maincolor text-xl font-light my-5" style="overflow: hidden;">
            Reparaciones en Electrónica
          </h3>

          <div class="md:my-7 md:w-3/4">
            <p class="text-justify md:text-xl lg:text-2xl" style="overflow: hidden;">
              SmartDrone es un servicio técnico con una base familiar en
              crecimiento y capacitación constante para dar un mejor servicio a
              nuestros clientes. Desde 2018, somos tu taller de confianza para
              reparar todo tipo de dispositivos electrónicos. Nuestro equipo de
              técnicos altamente capacitados garantiza un servicio eficiente.
              Somos el aliado estratégico de empresas importadoras, brindando
              servicios de garantía y soporte técnico especializado. Confía en
              nosotros para mantener tus dispositivos electrónicos funcionando
              como nuevos.
            </p>
          </div>
        </section>

        <section
          class="my-16 md:my-24 lg:my-32 min-h-[850px] sm:min-h-[600px] md:min-h-[650px] lg:min-h-[800px] xl:min-h-[950px] position-relative"
>
          <h2
            class="my-16 text-center text-ms-maincolor text-2xl sm:text-3xl md:text-4xl font-semibold overflow-hidden"
>
            CONTÁCTENOS
          </h2>
          <div class="display-flex justify-evenly xl:px-24">
            <img class="w-[88%] sm:w-auto md:h-full" src="/external/img/contact-us/contact-us-1.webp"
                 alt="Tienda SmartDrone"
>

            <img class="hidden sm:block w-auto md:h-full" src="/external/img/contact-us/contact-us-2.webp"
                 alt="SmartDrone Accesorios"
>

            <img class="hidden sm:block w-auto md:h-full" src="/external/img/contact-us/contact-us-3.webp"
                 alt="SmartDrone Reparaciones"
>
            <div
              class="display-flex justify-center align-items-center absolute bottom-0 width-screen h-2/4 text-ms-secondarycolor text-xs lg:text-base"
>
              <iframe title="Ubicacion SmartDrone"
                      class="shadow-xl w-11/12 sm:w-[55%] md:w-1/2 xl:w-[40%] h-[80%] rounded-lg"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3273.2195747114215!2d-56.18139992338171!3d-34.87583217192149!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f814df996df79%3A0xca0bf1675618129!2sSmartDrone%20Service!5e0!3m2!1ses!2suy!4v1726549474314!5m2!1ses!2suy"
                      style="border: 0" allowfullscreen="" loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
/>
              <div
                class="onlydesktop lg:w-auto px-5 h-[12%] absolute z-50 bg-ms-maincolor bottom-1/2 left-[5%] xl:left-[13%] 2xl:left-[18%] display-flex align-items-center justify-between"
>
                <svg width="28" height="28" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M44.9167 12.2501C44.9167 10.0042 43.0792 8.16675 40.8334 8.16675H8.16671C5.92087 8.16675 4.08337 10.0042 4.08337 12.2501V36.7501C4.08337 38.9959 5.92087 40.8334 8.16671 40.8334H40.8334C43.0792 40.8334 44.9167 38.9959 44.9167 36.7501V12.2501ZM40.8334 12.2501L24.5 22.4584L8.16671 12.2501H40.8334ZM40.8334 36.7501H8.16671V16.3334L24.5 26.5417L40.8334 16.3334V36.7501Z"
                    fill="white"
/>
                </svg>

                <span>recepcion@smartdrone.uy</span>
              </div>
              <div
                class="onlydesktop w-auto px-5 h-[12%] absolute z-50 bg-ms-maincolor bottom-[5%] right-[20%] xl:right-[25%] display-flex align-items-center justify-between"
>
                <svg width="22" height="22" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_96_40)">
                    <path
                      d="M31.4523 5.379C29.7563 3.66659 27.7364 2.30903 25.5102 1.38553C23.284 0.462031 20.8962 -0.00892815 18.4861 0.00012817C8.38744 0.00012817 0.15725 8.228 0.148 18.329C0.148 21.5642 0.994375 24.7115 2.59231 27.4981L0 37.0001L9.72175 34.4518C12.41 35.9184 15.4238 36.6858 18.4861 36.6833H18.4954C28.5964 36.6833 36.8242 28.4554 36.8335 18.3452C36.8356 15.9357 36.361 13.5496 35.437 11.3243C34.5131 9.099 33.1604 7.07845 31.4523 5.379ZM18.4861 33.5799C15.7555 33.5778 13.0754 32.8431 10.7254 31.4524L10.1704 31.1194L4.403 32.6318L5.94312 27.0055L5.58238 26.4251C4.05568 23.9977 3.24825 21.1873 3.25369 18.3198C3.25369 9.93463 10.0918 3.09425 18.4954 3.09425C20.4974 3.09066 22.4803 3.48339 24.3299 4.24979C26.1794 5.01619 27.8589 6.14111 29.2716 7.55969C30.689 8.97297 31.8126 10.6528 32.5778 12.5023C33.343 14.3518 33.7346 16.3344 33.7301 18.3359C33.7209 26.7511 26.8828 33.5799 18.4861 33.5799ZM26.8458 22.1701C26.3903 21.9411 24.1402 20.8334 23.717 20.6762C23.2961 20.5259 22.9886 20.4473 22.6879 20.9051C22.3804 21.3607 21.5016 22.399 21.238 22.6973C20.9744 23.0049 20.7015 23.0396 20.2436 22.8129C19.7881 22.5817 18.3104 22.1007 16.5621 20.5351C15.1978 19.3211 14.2843 17.8179 14.0114 17.3624C13.7478 16.9045 13.986 16.6594 14.2149 16.4304C14.4161 16.2269 14.6705 15.8939 14.8994 15.6303C15.1307 15.3667 15.207 15.1724 15.3573 14.8672C15.5076 14.5573 15.4359 14.2937 15.3226 14.0648C15.207 13.8358 14.2936 11.5765 13.9074 10.6654C13.5374 9.76582 13.1604 9.89069 12.8783 9.87913C12.6147 9.86294 12.3071 9.86294 11.9996 9.86294C11.7673 9.86885 11.5388 9.92263 11.3283 10.0209C11.1178 10.1192 10.9299 10.2599 10.7762 10.4341C10.3554 10.892 9.17831 11.9997 9.17831 14.259C9.17831 16.5183 10.8202 18.6898 11.0514 18.9973C11.2781 19.3049 14.2751 23.9276 18.8746 25.9163C19.9615 26.3904 20.8171 26.6702 21.4854 26.8829C22.5839 27.2344 23.5759 27.1813 24.3668 27.0679C25.2456 26.9338 27.0748 25.9579 27.4609 24.8873C27.8402 23.8143 27.8402 22.8985 27.7246 22.7066C27.6112 22.5123 27.3037 22.399 26.8458 22.1701Z"
                      fill="white"
/>
                  </g>
                  <defs>
                    <clipPath id="clip0_96_40">
                      <rect width="37" height="37" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>092062626</span>
              </div>
            </div>
          </div>
        </section>
        <section class="my-16 md:my-24 lg:my- grid xl:grid-cols-2 align-items-center 2xl:px-32">
          <div class="md:display-flex md:w-[312px] lg:w-[400px] xl:w-[512px] height-auto mx-auto">
            <img class="width-full h-full" src="/external/img/repairs-section/smartdrone-logo-repairs.webp"
                 alt="SmartDrone Logo"
>
          </div>

          <div
            class="m-0 md:mt-20 xl:m-0 display-flex display-flex-col align-items-center justify-around min-h-[700px]"
>
            <h2
              class="text-center text-ms-maincolor text-2xl sm:text-3xl md:text-4xl font-semibold overflow-hidden my-5"
>
              SOLUCIONES AL VUELO
            </h2>

            <p class="class= text-justify md:text-xl my-4">
              En SmartDrone somos expertos en reparar todo tipo de electrónica.
              Desde smartphones hasta drones, pasando por vehículos eléctricos
              monopatines, skate, notebook y electrónica en general, contamos
              con la experiencia y las herramientas necesarias para solucionar
              cualquier problema.
            </p>

            <div>
              <p class="text-left md:text-xl font-medium my-3">
                Nuestros servicios incluyen:
              </p>

              <ul class="list-disc list-inside list md:text-lg">
                <li class="p-1">Diagnóstico y reparación de placas.</li>
                <li class="p-1">Cambio de pantallas y baterías</li>
                <li class="p-1">
                  Cambio de piezas en IPhone manteniendo su condición original
                </li>
                <li class="p-1">Configuración y calibración de equipos</li>
                <li class="p-1">Solución de problemas de software</li>
              </ul>
            </div>

            <div class="display-flex display-flex-col width-full justify-around align-items-center min-h-32 mt-8">
              <span class="text-center lg:text-left md:text-lg font-medium">¡Contáctanos y solicita una idea del costo
                de tu reparación! </span><button
                class="mt-6 bg-ms-maincolor xs:w-[60%] md:w-[30%] md:min-h-[50px] padding-3 rounded-lg text-white hover:scale-105 transition-all ease-in-out duration-500"
>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfHqi7e1XFp0F21nX80PrOZlR3_jnxQVUTnPK6kLaetZcvzMw/viewform"
>Solicitar
                  Presupuesto</a>
              </button>
            </div>
          </div>
        </section>
        <section class="my-16 md:my-24 lg:my-32">
          <h2
            class="text-center text-ms-maincolor text-2xl sm:text-3xl md:text-4xl font-semibold overflow-hidden my-12"
>
            GALERIA DE FOTOS
          </h2>
          <div class="swiper w-[80%]">
            <div id="carrousel" class="list-none swiper-wrapper select-none min-h-[350px] overflow-visible">
              <div class="swiper-slide flex justify-center" v-for="(image, index) in imagesCarrousel" :key="index">
                <img 
                  class="w-[85%] sm:w-[60%] md:w-[90%] xl:w-[70%] rounded-lg shadow-xl"
                  :src="image.img"
                  :alt="image.name"
                >
              </div>
            </div>
          </div>
        </section>
      </div>
      <a href="https://wa.link/6gw6qz">
        <div
          class="fixed z-50 bottom-3 right-3 bg-green-500 rounded-full p-2 hover:scale-110 hover:bg-white transition-all ease-in-out"
>
          <svg class="w-10 h-10 md:w-14 md:h-14 lg:w-16 lg:height-16 text-white hover:text-green-500" aria-hidden="true"
               xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
>
            <path fill="currentColor" fill-rule="evenodd"
                  d="M12 4a8 8 0 0 0-6.895 12.06l.569.718-.697 2.359 2.32-.648.379.243A8 8 0 1 0 12 4ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.96 9.96 0 0 1-5.016-1.347l-4.948 1.382 1.426-4.829-.006-.007-.033-.055A9.958 9.958 0 0 1 2 12Z"
                  clip-rule="evenodd"
/>
            <path fill="currentColor"
                  d="M16.735 13.492c-.038-.018-1.497-.736-1.756-.83a1.008 1.008 0 0 0-.34-.075c-.196 0-.362.098-.49.291-.146.217-.587.732-.723.886-.018.02-.042.045-.057.045-.013 0-.239-.093-.307-.123-1.564-.68-2.751-2.313-2.914-2.589-.023-.04-.024-.057-.024-.057.005-.021.058-.074.085-.101.08-.079.166-.182.249-.283l.117-.14c.121-.14.175-.25.237-.375l.033-.066a.68.68 0 0 0-.02-.64c-.034-.069-.65-1.555-.715-1.711-.158-.377-.366-.552-.655-.552-.027 0 0 0-.112.005-.137.005-.883.104-1.213.311-.35.22-.94.924-.94 2.16 0 1.112.705 2.162 1.008 2.561l.041.06c1.161 1.695 2.608 2.951 4.074 3.537 1.412.564 2.081.63 2.461.63.16 0 .288-.013.4-.024l.072-.007c.488-.043 1.56-.599 1.804-1.276.192-.534.243-1.117.115-1.329-.088-.144-.239-.216-.43-.308Z"
/>
          </svg>
        </div>
      </a>
    </main>

    <footer class="display-flex justify-between min-h-[520px] lg:min-h-[250px] bg-ms-maincolor text-ms-secondarycolor">
      <div
        class="flex-vertical-phone my-0 mx-auto display-flex display-flex-row lg:display-flex-row justify-around lg:justify-between align-items-center text-sm md:text-base xl:text-lg"
>
        <div class="display-flex display-flex-col align-items-start lg:items-start">
          <div class="display-flex align-items-center">
            <svg width="28" height="28" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M31.0425 24.1987L30.1894 25.0481C30.1894 25.0481 28.1588 27.0656 22.6181 21.5568C17.0775 16.0481 19.1081 14.0306 19.1081 14.0306L19.6444 13.4943C20.97 12.1781 21.0956 10.0631 19.9388 8.51809L17.5763 5.36246C16.1438 3.44996 13.3781 3.19684 11.7375 4.82809L8.79377 7.75309C7.98189 8.56309 7.43814 9.60934 7.50377 10.7718C7.67252 13.7475 9.01877 20.1468 16.5263 27.6131C24.4894 35.5293 31.9613 35.8443 35.0156 35.5593C35.9831 35.4693 36.8231 34.9781 37.5 34.3031L40.1625 31.6556C41.9625 29.8687 41.4563 26.8031 39.1538 25.5525L35.5725 23.6043C34.0613 22.785 32.2238 23.025 31.0425 24.1987Z"
                fill="#6AB9D9"
/>
            </svg>
            <span class="p-2"><a class="transition-all ease-in-out duration-200 hover-text-ms-hoverColor"
                                 href="https://wa.link/6gw6qz"
>092062626</a></span>
          </div>
          <div class="display-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 43 43" fill="none">
              <g clip-path="url(#clip0_15_302)">
                <path
                  d="M21.5 0C15.6654 0 14.9318 0.026875 12.6393 0.129C10.3469 0.2365 8.78544 0.596625 7.4175 1.12875C5.98196 1.66712 4.682 2.51388 3.60931 3.60931C2.51388 4.682 1.66712 5.98196 1.12875 7.4175C0.596625 8.78275 0.233812 10.3469 0.129 12.6312C0.026875 14.9291 0 15.6601 0 21.5027C0 27.3399 0.026875 28.0709 0.129 30.3634C0.2365 32.6531 0.596625 34.2146 1.12875 35.5825C1.67969 36.9961 2.41338 38.1947 3.60931 39.3907C4.80256 40.5866 6.00119 41.323 7.41481 41.8713C8.78544 42.4034 10.3442 42.7662 12.6339 42.871C14.9291 42.9731 15.6601 43 21.5 43C27.3399 43 28.0683 42.9731 30.3634 42.871C32.6504 42.7635 34.2173 42.4034 35.5852 41.8713C37.0198 41.3325 38.3188 40.4858 39.3907 39.3907C40.5866 38.1947 41.3203 36.9961 41.8713 35.5825C42.4007 34.2146 42.7635 32.6531 42.871 30.3634C42.9731 28.0709 43 27.3399 43 21.5C43 15.6601 42.9731 14.9291 42.871 12.6339C42.7635 10.3469 42.4007 8.78275 41.8713 7.4175C41.3329 5.98196 40.4861 4.682 39.3907 3.60931C38.318 2.51388 37.018 1.66712 35.5825 1.12875C34.2119 0.596625 32.6478 0.233812 30.3607 0.129C28.0656 0.026875 27.3372 0 21.4946 0H21.5ZM19.5731 3.87538H21.5027C27.2432 3.87538 27.9231 3.89419 30.1887 3.999C32.2849 4.09306 33.4244 4.44513 34.1823 4.73806C35.1847 5.12775 35.9023 5.59538 36.6548 6.34788C37.4073 7.10038 37.8722 7.81525 38.2619 8.82038C38.5576 9.57556 38.9069 10.7151 39.001 12.8113C39.1058 15.0769 39.1273 15.7568 39.1273 21.4946C39.1273 27.2324 39.1058 27.9151 39.001 30.1806C38.9069 32.2769 38.5549 33.4137 38.2619 34.1716C37.9148 35.1039 37.365 35.9474 36.6521 36.6414C35.8996 37.3939 35.1847 37.8588 34.1796 38.2485C33.4271 38.5441 32.2876 38.8935 30.1887 38.9902C27.9231 39.0924 27.2432 39.1166 21.5027 39.1166C15.7622 39.1166 15.0796 39.0924 12.814 38.9902C10.7178 38.8935 9.58094 38.5441 8.82306 38.2485C7.89005 37.9025 7.04555 37.3536 6.35056 36.6414C5.63642 35.9469 5.08563 35.1024 4.73806 34.1689C4.44513 33.4137 4.09306 32.2742 3.999 30.1779C3.89688 27.9124 3.87538 27.2324 3.87538 21.4893C3.87538 15.7461 3.89688 15.0715 3.999 12.8059C4.09575 10.7097 4.44513 9.57019 4.74075 8.81231C5.13044 7.80988 5.59806 7.09231 6.35056 6.33981C7.10306 5.58731 7.81794 5.12238 8.82306 4.73269C9.58094 4.43706 10.7178 4.08769 12.814 3.99094C14.7974 3.89956 15.566 3.87269 19.5731 3.87V3.87538ZM32.9783 7.44438C32.6395 7.44438 32.304 7.51111 31.991 7.64077C31.678 7.77042 31.3936 7.96046 31.154 8.20004C30.9144 8.43961 30.7244 8.72403 30.5947 9.03705C30.465 9.35007 30.3983 9.68556 30.3983 10.0244C30.3983 10.3632 30.465 10.6987 30.5947 11.0117C30.7244 11.3247 30.9144 11.6091 31.154 11.8487C31.3936 12.0883 31.678 12.2783 31.991 12.408C32.304 12.5376 32.6395 12.6044 32.9783 12.6044C33.6626 12.6044 34.3188 12.3326 34.8026 11.8487C35.2865 11.3649 35.5583 10.7086 35.5583 10.0244C35.5583 9.34012 35.2865 8.68388 34.8026 8.20004C34.3188 7.7162 33.6626 7.44438 32.9783 7.44438ZM21.5027 10.4598C20.0382 10.4369 18.5838 10.7056 17.2241 11.2503C15.8645 11.7949 14.6268 12.6046 13.583 13.6321C12.5393 14.6597 11.7104 15.8846 11.1446 17.2356C10.5789 18.5866 10.2875 20.0367 10.2875 21.5013C10.2875 22.966 10.5789 24.4161 11.1446 25.7671C11.7104 27.118 12.5393 28.343 13.583 29.3706C14.6268 30.3981 15.8645 31.2078 17.2241 31.7524C18.5838 32.2971 20.0382 32.5658 21.5027 32.5429C24.4013 32.4977 27.1658 31.3145 29.1996 29.2487C31.2334 27.183 32.3734 24.4003 32.3734 21.5013C32.3734 18.6024 31.2334 15.8197 29.1996 13.754C27.1658 11.6882 24.4013 10.505 21.5027 10.4598ZM21.5027 14.3324C22.4439 14.3324 23.376 14.5178 24.2456 14.878C25.1152 15.2382 25.9054 15.7662 26.5709 16.4318C27.2365 17.0973 27.7644 17.8875 28.1247 18.7571C28.4849 19.6267 28.6702 20.5587 28.6702 21.5C28.6702 22.4413 28.4849 23.3733 28.1247 24.2429C27.7644 25.1125 27.2365 25.9027 26.5709 26.5682C25.9054 27.2338 25.1152 27.7618 24.2456 28.122C23.376 28.4822 22.4439 28.6676 21.5027 28.6676C19.6017 28.6676 17.7786 27.9124 16.4345 26.5682C15.0903 25.2241 14.3351 23.401 14.3351 21.5C14.3351 19.599 15.0903 17.7759 16.4345 16.4318C17.7786 15.0876 19.6017 14.3324 21.5027 14.3324Z"
                  fill="#6AB9D9"
/>
              </g>
              <defs>
                <clipPath id="clip0_15_302">
                  <rect width="43" height="43" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <a class="p-2 transition-all ease-in-out duration-200 hover-text-ms-hoverColor"
               href="https://www.instagram.com/smartdrone.uy/"
>smartdrone.uy</a>
          </div>
          <div class="display-flex align-items-center">
            <svg width="28" height="28" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M44.9166 12.2498C44.9166 10.004 43.0791 8.1665 40.8333 8.1665H8.16665C5.92081 8.1665 4.08331 10.004 4.08331 12.2498V36.7498C4.08331 38.9957 5.92081 40.8332 8.16665 40.8332H40.8333C43.0791 40.8332 44.9166 38.9957 44.9166 36.7498V12.2498ZM40.8333 12.2498L24.5 22.4582L8.16665 12.2498H40.8333ZM40.8333 36.7498H8.16665V16.3332L24.5 26.5415L40.8333 16.3332V36.7498Z"
                fill="#6AB9D9"
/>
            </svg>
            <span class="p-2">recepcion@smartdrone.uy</span>
          </div>
          <div class="display-flex align-items-center">
            <svg width="28" height="28" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M44.9166 12.2498C44.9166 10.004 43.0791 8.1665 40.8333 8.1665H8.16665C5.92081 8.1665 4.08331 10.004 4.08331 12.2498V36.7498C4.08331 38.9957 5.92081 40.8332 8.16665 40.8332H40.8333C43.0791 40.8332 44.9166 38.9957 44.9166 36.7498V12.2498ZM40.8333 12.2498L24.5 22.4582L8.16665 12.2498H40.8333ZM40.8333 36.7498H8.16665V16.3332L24.5 26.5415L40.8333 16.3332V36.7498Z"
                fill="#6AB9D9"
/>
            </svg>
            <span class="p-2">smartdroneoficialuruguay@gmail.com</span>
          </div>
        </div>
        <img class="w-[230px] xl:w-[280px] height-auto" src="/external/img/smartdrone-logo.webp"
             alt="SmartDrone Logo"
>
        <div class="display-flex display-flex-col">
          <div class="display-flex display-flex-col align-items-center">
            <div class="display-flex width-full justify-center lg:justify-end align-items-center">
              <span class="p-2">General Flores 2830 </span>
              <svg width="28" height="28" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M44.1524 14.5002C46.5933 19.7443 46.0374 25.931 43.3549 30.9577C41.0833 35.0418 37.8208 38.4977 35.0416 42.2918C33.8333 43.9835 32.6249 45.796 31.7308 47.7535C31.4166 48.406 31.1991 49.0827 30.9574 49.7593C30.7158 50.436 30.4983 51.1127 30.2808 51.7893C30.0633 52.4177 29.7974 53.1668 28.9999 53.1668C28.0574 53.1668 27.7916 52.1035 27.5983 51.3785C27.0183 49.6143 26.4383 47.9227 25.5441 46.3035C24.5291 44.3943 23.2483 42.6302 21.9433 40.9143L44.1524 14.5002ZM22.0399 20.3485L14.0649 29.8218C15.5391 32.9393 17.7383 35.5977 19.8408 38.256C20.3483 38.8602 20.8558 39.4885 21.3391 40.141L31.4166 28.2027L31.3199 28.2268C27.7916 29.4352 23.8766 27.6468 22.4749 24.1668C22.2816 23.756 22.1366 23.2727 22.0399 22.7893C21.9047 21.9894 21.9047 21.1725 22.0399 20.3727V20.3485ZM15.9016 11.1652L15.8774 11.1893C11.9624 16.1435 11.2858 23.031 13.6299 28.8552L23.2724 17.4002L23.1516 17.2793L15.9016 11.1652ZM34.3649 5.7035L26.5833 14.911L26.6799 14.8868C29.9183 13.7752 33.5433 15.1768 35.1866 18.1252C35.5491 18.8018 35.8391 19.5268 35.9358 20.2518C36.0808 21.1702 36.1291 21.8227 35.9599 22.7168V22.741L43.6933 13.5577C41.6696 9.88464 38.3538 7.0942 34.3891 5.72766L34.3649 5.7035ZM23.9008 16.651L33.3499 5.4135L33.2533 5.38933C31.8516 5.02683 30.4258 4.8335 28.9999 4.8335C24.2391 4.8335 19.7441 6.88766 16.5541 10.416L16.5058 10.4402L23.9008 16.651Z"
                  fill="#6AB9D9"
/>
              </svg>
            </div>

            <span class="p-2">Esquina Ceibal. Barrio Goes. Mdeo, Uy.</span>
          </div>
          <div class="display-flex align-items-center lg:justify-end">
            <span class="p-2">Lunes a Viernes - 9:30hs a 18:00 hs </span>
            <svg width="28" height="28" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_15_347)">
                <path
                  d="M39.875 22C39.875 26.7407 37.9917 31.2873 34.6395 34.6395C31.2873 37.9917 26.7407 39.875 22 39.875C17.2593 39.875 12.7127 37.9917 9.36047 34.6395C6.00825 31.2873 4.125 26.7407 4.125 22C4.125 17.2593 6.00825 12.7127 9.36047 9.36047C12.7127 6.00825 17.2593 4.125 22 4.125C26.7407 4.125 31.2873 6.00825 34.6395 9.36047C37.9917 12.7127 39.875 17.2593 39.875 22ZM0 22C0 27.8348 2.31785 33.4305 6.44365 37.5564C10.5695 41.6822 16.1652 44 22 44C27.8348 44 33.4305 41.6822 37.5564 37.5564C41.6822 33.4305 44 27.8348 44 22C44 16.1652 41.6822 10.5695 37.5564 6.44365C33.4305 2.31785 27.8348 0 22 0C16.1652 0 10.5695 2.31785 6.44365 6.44365C2.31785 10.5695 0 16.1652 0 22ZM19.9375 10.3125V22C19.9375 22.6875 20.2812 23.332 20.857 23.7188L29.107 29.2188C30.0523 29.8547 31.3328 29.5969 31.9688 28.643C32.6047 27.6891 32.3469 26.4172 31.393 25.7812L24.0625 20.9V10.3125C24.0625 9.16953 23.143 8.25 22 8.25C20.857 8.25 19.9375 9.16953 19.9375 10.3125Z"
                  fill="#6AB9D9"
/>
              </g>
              <defs>
                <clipPath id="clip0_15_347">
                  <rect width="44" height="44" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

        </div>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
    name: 'Landing',
    data() {
        return {
            menuClosed: true,
            imagesCarrousel: [
                {img:'/external/img/carrousel-images/image-1.webp', name:'SmartDrone Tienda'}, {img:'/external/img/carrousel-images/image-2.webp',name:'SmartDrone Tienda General Flores'},{img:'/external/img/carrousel-images/image-3.webp',name:'Puestos de trabajo'},{img:'/external/img/carrousel-images/image-4.webp',name:'Servicio Técnico'},{img:'/external/img/carrousel-images/image-5.webp',name:'Reparación Imagen'},{img:'/external/img/carrousel-images/image-6.webp',name:'Reparación de laptop'},{img:'/external/img/carrousel-images/image-7.webp',name:'Reparación de Macbook'},{img:'/external/img/carrousel-images/image-8.webp',name:'Reparación de notebook'},{img:'/external/img/carrousel-images/image-9.webp',name:'Reparación de puerto usb'},{img:'/external/img/carrousel-images/image-10.webp',name:'Reparación en Placa Electrónica'}
            ],
            categoriesList: [{iconImage:'/external/img/cards-icons/tablet.webp', name:'Tablet'}, {iconImage:'/external/img/cards-icons/phone.webp',name:'Celulares'},{iconImage:'/external/img/cards-icons/notebook.webp',name:'Notebooks'},{iconImage:'/external/img/cards-icons/drone.webp',name:'Drones'},{iconImage:'/external/img/cards-icons/scooter.webp',name:'Monopatines'},{iconImage:'/external/img/cards-icons/skateboard.webp',name:'Skateboard'},{iconImage:'/external/img/cards-icons/tablet.webp',name:'Placas electronicas'},{iconImage:'/external/img/cards-icons/television.webp',name:'Televisores'},{iconImage:'/external/img/cards-icons/game-console.webp',name:'Consolas'},{iconImage:'/external/img/cards-icons/multimedia.webp',name:'Multimedia'},{iconImage:'/external/img/cards-icons/accessories.webp',name:'Accesorios'},{iconImage:'/external/img/cards-icons/conectivity.webp',name:'Conectividad'}]
        };
    },
    mounted() {
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js');
        document.head.appendChild(recaptchaScript);

        setTimeout(function notienenombre() {
            // eslint-disable-next-line no-new
            new Swiper('.swiper', {
                loop: true,
                spaceBetween: 20,

                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },

                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                },
            });
        }, 1000);
    },
    methods: {
        menuToggle() {
            if (this.menuClosed) {
                this.menuClosed = false;
            } else {
                this.menuClosed = true;
            }
        }
    }
};
</script>
<style scoped lang="scss">
@import '/external/dist/styles.css';
@import url('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css');

.bg-cover {
  background-size: cover;
}

.bg-center {
  background-position: center;
}

.width-full {
  width: 100%;
}

.position-relative {
  position: relative;
}

.overflow-visible {
  overflow: visible;
}

.width-screen {
  width: 100vw;
}

.display-flex {
  display: flex;
}

.md-justify-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.height-16 {
  height: 4rem;
}

.lg-height-32 {
  height: 8rem;
}

.padding-left-3 {
  padding-left: 0.75rem;
}

.sm-padding-x-7px {
  padding-left: 7px;
  padding-right: 7px;
}

.md-padding-x-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.lg-margin-auto {
  margin: auto;
}

.width-48 {
  width: 12rem;
}

.md-width-64 {
  width: 16rem;
}

.height-auto {
  height: auto;
}

.flex-col {
  flex-direction: column;
}

.sm-flex-row {
  flex-direction: row;
}

.text-sm {
  font-size: 0.875rem;
}

.padding-3 {
  padding: 0.75rem;
}

.sm-padding-2 {
  padding: 0.5rem;
}

.xl-padding-5 {
  padding: 1.25rem;
}

.sm-text-base {
  font-size: 1rem;
}

.lg-text-xl {
  font-size: 1.25rem;
}

.transition-all {
  transition: all 0.3s ease;
}

.hover-text-ms-hoverColor:hover {
  color: var(--ms-hoverColor);
}
.display-flex-col {
  flex-direction: column;
}
.display-flex-wrap {
  flex-wrap: wrap;
}
.align-items-start {
  align-items: flex-start !important;
}
.onlydesktop {
  @media(max-width: 600px) {
    display: none;
  }
}
.flex-vertical-phone {
  @media(max-width: 600px) {
    flex-direction: column;
    .align-items-start {
      align-items: center !important;
    }
  }
}
.desktop-open {
  @media(min-width: 600px) {
    height: auto;
    opacity: 1 !important;
  }
}
.menuOpened {
  flex-direction: column;
  border: 1px solid;
  border-radius: 10px;
  margin-top: 15px;
}
</style>